(function () {
  'use strict';

  function initStoryLoop(root) {
    if (!root || root.dataset.agCfStoryBound === 'true') return;

    var track = root.querySelector('[data-ag-cf-story-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ag-cf-story-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ag-cf-story-dot]'));
    var progress = root.querySelector('[data-ag-cf-story-progress]');
    if (!track || slides.length < 2) return;

    root.dataset.agCfStoryBound = 'true';

    var mobileTouchMode = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    track.style.touchAction = 'pan-y';
    if (mobileTouchMode) {
      track.style.width = 'calc(100vw - 28px)';
      track.style.overflowX = 'hidden';
      track.style.scrollSnapType = 'none';
    }

    var total = slides.length;
    var leadingClones = [];
    var trailingClones = [];
    var allSlides;
    var normalizeTimer;
    var scrollIdleTimer;
    var normalizationEpoch = 0;
    var leadingCloneCount;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartIndex = null;
    var touchStartOffset = 0;
    var touchStartScrollLeft = 0;
    var touchActive = false;
    var touchEndPending = false;
    var controlTransitionPending = false;
    var preloadedImages = [];

    function preloadImages() {
      slides.forEach(function (slide, slideIndex) {
        var image = slide.querySelector('img');
        if (!image) return;

        image.setAttribute('loading', 'eager');
        image.setAttribute('decoding', 'async');
        if (slideIndex === 0) image.setAttribute('fetchpriority', 'high');

        var src = image.currentSrc || image.getAttribute('src');
        var srcset = image.getAttribute('srcset');
        if (!src && !srcset) return;

        var preload = new Image();
        if (srcset) preload.srcset = srcset;
        if (image.sizes) preload.sizes = image.sizes;
        if (src) preload.src = src;
        preloadedImages.push(preload);
      });
    }

    function prepareClone(clone) {
      clone.removeAttribute('data-ag-cf-story-slide');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-ag-cf-story-clone', 'true');
      clone.classList.add('ag-cf-v3__story-slide--clone');
    }

    for (var cloneIndex = 0; cloneIndex < total; cloneIndex += 1) {
      var leadingClone = slides[total - 1 - cloneIndex].cloneNode(true);
      var trailingClone = slides[cloneIndex].cloneNode(true);
      prepareClone(leadingClone);
      prepareClone(trailingClone);
      leadingClones.unshift(leadingClone);
      trailingClones.push(trailingClone);
    }

    preloadImages();

    leadingClones.slice().reverse().forEach(function (clone) {
      track.insertBefore(clone, track.firstChild);
    });
    trailingClones.forEach(function (clone) {
      track.appendChild(clone);
    });

    leadingCloneCount = leadingClones.length;
    allSlides = leadingClones.concat(slides, trailingClones);

    function getSlideOffset(index) {
      var slide = allSlides[index];
      var trackRect = track.getBoundingClientRect();
      var slideRect = slide.getBoundingClientRect();
      return track.scrollLeft + slideRect.left - trackRect.left;
    }

    function getNearestIndex() {
      var closestIndex = 0;
      var closestDistance = Infinity;

      allSlides.forEach(function (slide, index) {
        var distance = Math.abs(track.scrollLeft - getSlideOffset(index));
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function getRealIndex(index) {
      var realIndex = (index - leadingCloneCount) % total;
      return realIndex < 0 ? realIndex + total : realIndex;
    }

    function setActive(index) {
      var realIndex = getRealIndex(index);
      var activeOriginalIndex = leadingCloneCount + realIndex;

      if (progress) {
        progress.textContent = String(realIndex + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
      }

      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === realIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      slides.forEach(function (slide, slideIndex) {
        var active = leadingCloneCount + slideIndex === activeOriginalIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-current', active ? 'true' : 'false');
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    function cancelNormalization() {
      normalizationEpoch += 1;
      window.clearTimeout(normalizeTimer);
      window.clearTimeout(scrollIdleTimer);
      normalizeTimer = null;
      scrollIdleTimer = null;
    }

    function normalizeBoundary() {
      if (touchActive) return;

      cancelNormalization();

      var index = getNearestIndex();
      var normalizedIndex = index;

      if (index < leadingCloneCount) normalizedIndex = index + total;
      if (index >= leadingCloneCount + total) normalizedIndex = index - total;

      var previousScrollSnapType = track.style.scrollSnapType;
      var previousScrollBehavior = track.style.scrollBehavior;

      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = getSlideOffset(normalizedIndex);

      if (normalizedIndex !== index) {
        window.requestAnimationFrame(function () {
          track.style.scrollSnapType = previousScrollSnapType;
          track.style.scrollBehavior = previousScrollBehavior;
        });
      } else {
        track.style.scrollSnapType = previousScrollSnapType;
        track.style.scrollBehavior = previousScrollBehavior;
      }

      touchEndPending = false;
      controlTransitionPending = false;
      setActive(normalizedIndex);
    }

    function scheduleNormalization(delay) {
      if (touchActive) return;

      window.clearTimeout(normalizeTimer);
      var epoch = normalizationEpoch + 1;
      normalizationEpoch = epoch;
      normalizeTimer = window.setTimeout(function () {
        if (epoch !== normalizationEpoch || touchActive) return;
        normalizeBoundary();
      }, delay);
    }

    function scheduleScrollIdleNormalization() {
      if (touchActive) return;

      window.clearTimeout(scrollIdleTimer);
      scrollIdleTimer = window.setTimeout(function () {
        scrollIdleTimer = null;
        if (touchActive) return;
        normalizeBoundary();
      }, 240);
    }

    function goToAdjacent(direction, startingIndex, startingOffset) {
      cancelNormalization();
      touchEndPending = false;
      controlTransitionPending = true;

      var currentIndex = typeof startingIndex === 'number' ? startingIndex : getNearestIndex();

      if (typeof startingOffset === 'number' && Math.abs(track.scrollLeft - startingOffset) > 0.5) {
        var previousScrollSnapType = track.style.scrollSnapType;
        var previousScrollBehavior = track.style.scrollBehavior;
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = startingOffset;
        track.style.scrollSnapType = previousScrollSnapType;
        track.style.scrollBehavior = previousScrollBehavior;
      }

      var targetIndex = currentIndex + direction;

      if (targetIndex < 0 || targetIndex >= allSlides.length) {
        normalizeBoundary();
        currentIndex = getNearestIndex();
        targetIndex = currentIndex + direction;
      }

      track.scrollTo({ left: getSlideOffset(targetIndex), behavior: 'smooth' });
      setActive(targetIndex);
      scheduleNormalization(900);
    }

    function goToRealIndex(index) {
      cancelNormalization();
      touchEndPending = false;
      controlTransitionPending = true;

      var normalized = (index + total) % total;
      var targetIndex = leadingCloneCount + normalized;
      track.scrollTo({ left: getSlideOffset(targetIndex), behavior: 'smooth' });
      setActive(targetIndex);
      scheduleNormalization(900);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToRealIndex(Number(dot.dataset.agCfStoryDot));
      });
    });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goToAdjacent(-1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goToAdjacent(1);
      }
    });

    track.addEventListener('scroll', function () {
      setActive(getNearestIndex());
      scheduleScrollIdleNormalization();
    }, { passive: true });

    track.addEventListener('scrollend', function () {
      if (touchActive) return;
      if (touchEndPending || controlTransitionPending) scheduleNormalization(80);
    }, { passive: true });

    track.addEventListener('touchstart', function (event) {
      var touch = event.touches[0];
      if (!touch) return;

      cancelNormalization();
      touchEndPending = false;
      controlTransitionPending = false;
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchStartIndex = getNearestIndex();
      touchStartOffset = getSlideOffset(touchStartIndex);
      touchStartScrollLeft = track.scrollLeft;
      touchActive = true;
    }, { passive: true });

    track.addEventListener('touchend', function (event) {
      if (!touchActive) return;
      touchActive = false;

      var touch = event.changedTouches[0];
      if (!touch) {
        touchEndPending = false;
        touchStartIndex = null;
        return;
      }

      var deltaX = touch.clientX - touchStartX;
      var deltaY = touch.clientY - touchStartY;
      var horizontalSwipe = Math.abs(deltaX) >= 24 && Math.abs(deltaX) > Math.abs(deltaY);
      var nativeScrollMoved = Math.abs(track.scrollLeft - touchStartScrollLeft) >= 24;

      if (horizontalSwipe && !nativeScrollMoved) {
        goToAdjacent(deltaX < 0 ? 1 : -1, touchStartIndex, touchStartOffset);
        touchStartIndex = null;
        return;
      }

      touchEndPending = horizontalSwipe || nativeScrollMoved;
      if (touchEndPending) scheduleNormalization(650);
      touchStartIndex = null;
    }, { passive: true });

    track.addEventListener('touchcancel', function () {
      touchActive = false;
      touchEndPending = true;
      touchStartIndex = null;
      scheduleNormalization(650);
    }, { passive: true });

    track.scrollLeft = getSlideOffset(leadingCloneCount);
    setActive(leadingCloneCount);
  }

  function init() {
    document.querySelectorAll('[data-ag-cf-story-loop]').forEach(initStoryLoop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}());
